// removed by extract-text-webpack-plugin
module.exports = {"action-panel":"action-panel","business-info":"business-info","box-image":"box-image","box-content":"box-content","box-text":"box-text","label-medium":"label-medium"};


//////////////////
// WEBPACK FOOTER
// ./components/business/_BusinessInfo.scss
// module id = ./components/business/_BusinessInfo.scss
// module chunks = 0